/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Error_Modal_DescriptionInputs */

const en_validation_error_modal_description = /** @type {(inputs: Validation_Error_Modal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please review and fix the validation errors before proceeding to the next step, or continue anyway to proceed with invalid data.`)
};

const nl_validation_error_modal_description = /** @type {(inputs: Validation_Error_Modal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controleer alstublieft en corrigeer de validatiefouten voordat u doorgaat naar de volgende stap, of ga toch door met ongeldige gegevens.`)
};

/**
* | output |
* | --- |
* | "Please review and fix the validation errors before proceeding to the next step, or continue anyway to proceed with invalid data." |
*
* @param {Validation_Error_Modal_DescriptionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const validation_error_modal_description = /** @type {((inputs?: Validation_Error_Modal_DescriptionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Error_Modal_DescriptionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_validation_error_modal_description(inputs)
	return en_validation_error_modal_description(inputs)
});